import { render } from "./ProductSelection.vue?vue&type=template&id=5c49916f&scoped=true"
import script from "./ProductSelection.vue?vue&type=script&lang=js"
export * from "./ProductSelection.vue?vue&type=script&lang=js"

import "./ProductSelection.vue?vue&type=style&index=0&id=5c49916f&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c49916f"]])

export default __exports__